/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Rocket.net API
 * Rocket.net - All APIs
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery, useSuspenseQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';

import { customFetch } from '../../custom-fetch';
import { addMetaToQuery } from '../../mutators/add-meta';
import { addMetaToMutation } from '../../mutators/add-meta';
import type {
  ChangePluginStatusPluginRequest,
  ChangePluginStatusResponse,
  DeletePluginRequest,
  DeletePluginResponse,
  Error,
  InstallPluginsRequest,
  InstallPluginsResponse,
  ListFeaturedPluginsResponse,
  ListPluginsResponse,
  ListSitePluginsParams,
  SearchPluginsResponse,
  SearchSitePluginsParams,
  SiteID,
  SuccessResponse,
  UpdatePluginRequest,
  UpdatePluginResponse,
} from '../rocketNetAPI.schemas';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

/**
 * Returns Rocket's curated plugin list for this site, including whether each plugin is installed, active, or has updates available. WordPress sites only.
 * @summary List recommended WordPress plugins
 */
export const listSiteFeaturedPlugins = (id: SiteID, signal?: AbortSignal) => {
  return customFetch<ListFeaturedPluginsResponse>({
    url: `/v1/sites/${id}/featured_plugins`,
    method: 'GET',
    signal,
  });
};

export const getListSiteFeaturedPluginsQueryKey = (id?: SiteID) => {
  return [`/v1/sites/${id}/featured_plugins`] as const;
};

export const getListSiteFeaturedPluginsQueryOptions = <
  TData = Awaited<ReturnType<typeof listSiteFeaturedPlugins>>,
  TError = Error,
>(
  id: SiteID,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSiteFeaturedPlugins>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListSiteFeaturedPluginsQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listSiteFeaturedPlugins>>> = ({
    signal,
  }) => listSiteFeaturedPlugins(id, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id },
    {
      url: `/v1/sites/${id}/featured_plugins`,
      operationId: 'app.controllers.plugins_controller.list_site_featured_plugins',
      operationName: 'listSiteFeaturedPlugins',
    }
  );

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof listSiteFeaturedPlugins>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListSiteFeaturedPluginsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSiteFeaturedPlugins>>
>;
export type ListSiteFeaturedPluginsQueryError = Error;

export function useListSiteFeaturedPlugins<
  TData = Awaited<ReturnType<typeof listSiteFeaturedPlugins>>,
  TError = Error,
>(
  id: SiteID,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSiteFeaturedPlugins>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSiteFeaturedPlugins>>,
          TError,
          Awaited<ReturnType<typeof listSiteFeaturedPlugins>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSiteFeaturedPlugins<
  TData = Awaited<ReturnType<typeof listSiteFeaturedPlugins>>,
  TError = Error,
>(
  id: SiteID,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSiteFeaturedPlugins>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSiteFeaturedPlugins>>,
          TError,
          Awaited<ReturnType<typeof listSiteFeaturedPlugins>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSiteFeaturedPlugins<
  TData = Awaited<ReturnType<typeof listSiteFeaturedPlugins>>,
  TError = Error,
>(
  id: SiteID,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSiteFeaturedPlugins>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List recommended WordPress plugins
 */

export function useListSiteFeaturedPlugins<
  TData = Awaited<ReturnType<typeof listSiteFeaturedPlugins>>,
  TError = Error,
>(
  id: SiteID,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSiteFeaturedPlugins>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListSiteFeaturedPluginsQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getListSiteFeaturedPluginsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof listSiteFeaturedPlugins>>,
  TError = Error,
>(
  id: SiteID,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSiteFeaturedPlugins>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListSiteFeaturedPluginsQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listSiteFeaturedPlugins>>> = ({
    signal,
  }) => listSiteFeaturedPlugins(id, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id },
    {
      url: `/v1/sites/${id}/featured_plugins`,
      operationId: 'app.controllers.plugins_controller.list_site_featured_plugins',
      operationName: 'listSiteFeaturedPlugins',
    }
  );

  return customOptions as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof listSiteFeaturedPlugins>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListSiteFeaturedPluginsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSiteFeaturedPlugins>>
>;
export type ListSiteFeaturedPluginsSuspenseQueryError = Error;

export function useListSiteFeaturedPluginsSuspense<
  TData = Awaited<ReturnType<typeof listSiteFeaturedPlugins>>,
  TError = Error,
>(
  id: SiteID,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSiteFeaturedPlugins>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSiteFeaturedPluginsSuspense<
  TData = Awaited<ReturnType<typeof listSiteFeaturedPlugins>>,
  TError = Error,
>(
  id: SiteID,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSiteFeaturedPlugins>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSiteFeaturedPluginsSuspense<
  TData = Awaited<ReturnType<typeof listSiteFeaturedPlugins>>,
  TError = Error,
>(
  id: SiteID,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSiteFeaturedPlugins>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List recommended WordPress plugins
 */

export function useListSiteFeaturedPluginsSuspense<
  TData = Awaited<ReturnType<typeof listSiteFeaturedPlugins>>,
  TError = Error,
>(
  id: SiteID,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSiteFeaturedPlugins>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListSiteFeaturedPluginsSuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns plugins installed on this site, with status, version, and available updates. Supports search, pagination, and sorting. WordPress sites only.
 * @summary List installed WordPress plugins
 */
export const listSitePlugins = (
  id: SiteID,
  params?: ListSitePluginsParams,
  signal?: AbortSignal
) => {
  return customFetch<ListPluginsResponse>({
    url: `/v1/sites/${id}/plugins`,
    method: 'GET',
    params,
    signal,
  });
};

export const getListSitePluginsQueryKey = (id?: SiteID, params?: ListSitePluginsParams) => {
  return [`/v1/sites/${id}/plugins`, ...(params ? [params] : [])] as const;
};

export const getListSitePluginsQueryOptions = <
  TData = Awaited<ReturnType<typeof listSitePlugins>>,
  TError = Error,
>(
  id: SiteID,
  params?: ListSitePluginsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSitePlugins>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListSitePluginsQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listSitePlugins>>> = ({ signal }) =>
    listSitePlugins(id, params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, params },
    {
      url: `/v1/sites/${id}/plugins`,
      operationId: 'app.controllers.plugins_controller.list_site_plugins',
      operationName: 'listSitePlugins',
    }
  );

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof listSitePlugins>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListSitePluginsQueryResult = NonNullable<Awaited<ReturnType<typeof listSitePlugins>>>;
export type ListSitePluginsQueryError = Error;

export function useListSitePlugins<
  TData = Awaited<ReturnType<typeof listSitePlugins>>,
  TError = Error,
>(
  id: SiteID,
  params: undefined | ListSitePluginsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSitePlugins>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSitePlugins>>,
          TError,
          Awaited<ReturnType<typeof listSitePlugins>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSitePlugins<
  TData = Awaited<ReturnType<typeof listSitePlugins>>,
  TError = Error,
>(
  id: SiteID,
  params?: ListSitePluginsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSitePlugins>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSitePlugins>>,
          TError,
          Awaited<ReturnType<typeof listSitePlugins>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSitePlugins<
  TData = Awaited<ReturnType<typeof listSitePlugins>>,
  TError = Error,
>(
  id: SiteID,
  params?: ListSitePluginsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSitePlugins>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List installed WordPress plugins
 */

export function useListSitePlugins<
  TData = Awaited<ReturnType<typeof listSitePlugins>>,
  TError = Error,
>(
  id: SiteID,
  params?: ListSitePluginsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSitePlugins>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListSitePluginsQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getListSitePluginsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof listSitePlugins>>,
  TError = Error,
>(
  id: SiteID,
  params?: ListSitePluginsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSitePlugins>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListSitePluginsQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listSitePlugins>>> = ({ signal }) =>
    listSitePlugins(id, params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, params },
    {
      url: `/v1/sites/${id}/plugins`,
      operationId: 'app.controllers.plugins_controller.list_site_plugins',
      operationName: 'listSitePlugins',
    }
  );

  return customOptions as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof listSitePlugins>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListSitePluginsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSitePlugins>>
>;
export type ListSitePluginsSuspenseQueryError = Error;

export function useListSitePluginsSuspense<
  TData = Awaited<ReturnType<typeof listSitePlugins>>,
  TError = Error,
>(
  id: SiteID,
  params: undefined | ListSitePluginsParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSitePlugins>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSitePluginsSuspense<
  TData = Awaited<ReturnType<typeof listSitePlugins>>,
  TError = Error,
>(
  id: SiteID,
  params?: ListSitePluginsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSitePlugins>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSitePluginsSuspense<
  TData = Awaited<ReturnType<typeof listSitePlugins>>,
  TError = Error,
>(
  id: SiteID,
  params?: ListSitePluginsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSitePlugins>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List installed WordPress plugins
 */

export function useListSitePluginsSuspense<
  TData = Awaited<ReturnType<typeof listSitePlugins>>,
  TError = Error,
>(
  id: SiteID,
  params?: ListSitePluginsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSitePlugins>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListSitePluginsSuspenseQueryOptions(id, params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Installs one or more plugins from the WordPress plugin directory or from a custom download URL. Optionally activates plugins after install. WordPress sites only.
 * @summary Install WordPress plugins
 */
export const installSitePlugin = (
  id: SiteID,
  installPluginsRequest: InstallPluginsRequest,
  signal?: AbortSignal
) => {
  return customFetch<InstallPluginsResponse>({
    url: `/v1/sites/${id}/plugins`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: installPluginsRequest,
    signal,
  });
};

export const getInstallSitePluginMutationOptions = <TError = Error, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof installSitePlugin>>,
    TError,
    { id: SiteID; data: InstallPluginsRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof installSitePlugin>>,
  TError,
  { id: SiteID; data: InstallPluginsRequest },
  TContext
> => {
  const mutationKey = ['installSitePlugin'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof installSitePlugin>>,
    { id: SiteID; data: InstallPluginsRequest }
  > = props => {
    const { id, data } = props ?? {};

    return installSitePlugin(id, data);
  };

  const customOptions = addMetaToMutation(
    { ...mutationOptions, mutationFn },
    { url: `/v1/sites/{id}/plugins` },
    {
      operationId: 'app.controllers.plugins_controller.install_site_plugin',
      operationName: 'installSitePlugin',
    }
  );

  return customOptions;
};

export type InstallSitePluginMutationResult = NonNullable<
  Awaited<ReturnType<typeof installSitePlugin>>
>;
export type InstallSitePluginMutationBody = InstallPluginsRequest;
export type InstallSitePluginMutationError = Error;

/**
 * @summary Install WordPress plugins
 */
export const useInstallSitePlugin = <TError = Error, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof installSitePlugin>>,
      TError,
      { id: SiteID; data: InstallPluginsRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof installSitePlugin>>,
  TError,
  { id: SiteID; data: InstallPluginsRequest },
  TContext
> => {
  const mutationOptions = getInstallSitePluginMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Activates or deactivates an installed plugin by slug. WordPress sites only.
 * @summary Activate or deactivate a WordPress plugin
 */
export const togglePluginStatus = (
  id: SiteID,
  changePluginStatusPluginRequest: ChangePluginStatusPluginRequest
) => {
  return customFetch<ChangePluginStatusResponse>({
    url: `/v1/sites/${id}/plugins`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: changePluginStatusPluginRequest,
  });
};

export const getTogglePluginStatusMutationOptions = <TError = Error, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof togglePluginStatus>>,
    TError,
    { id: SiteID; data: ChangePluginStatusPluginRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof togglePluginStatus>>,
  TError,
  { id: SiteID; data: ChangePluginStatusPluginRequest },
  TContext
> => {
  const mutationKey = ['togglePluginStatus'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof togglePluginStatus>>,
    { id: SiteID; data: ChangePluginStatusPluginRequest }
  > = props => {
    const { id, data } = props ?? {};

    return togglePluginStatus(id, data);
  };

  const customOptions = addMetaToMutation(
    { ...mutationOptions, mutationFn },
    { url: `/v1/sites/{id}/plugins` },
    {
      operationId: 'app.controllers.plugins_controller.toggle_plugin_status',
      operationName: 'togglePluginStatus',
    }
  );

  return customOptions;
};

export type TogglePluginStatusMutationResult = NonNullable<
  Awaited<ReturnType<typeof togglePluginStatus>>
>;
export type TogglePluginStatusMutationBody = ChangePluginStatusPluginRequest;
export type TogglePluginStatusMutationError = Error;

/**
 * @summary Activate or deactivate a WordPress plugin
 */
export const useTogglePluginStatus = <TError = Error, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof togglePluginStatus>>,
      TError,
      { id: SiteID; data: ChangePluginStatusPluginRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof togglePluginStatus>>,
  TError,
  { id: SiteID; data: ChangePluginStatusPluginRequest },
  TContext
> => {
  const mutationOptions = getTogglePluginStatusMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Updates an installed plugin to its latest available version. WordPress sites only.
 * @summary Update a WordPress plugin
 */
export const updateSitePlugin = (id: SiteID, updatePluginRequest: UpdatePluginRequest) => {
  return customFetch<UpdatePluginResponse>({
    url: `/v1/sites/${id}/plugins`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updatePluginRequest,
  });
};

export const getUpdateSitePluginMutationOptions = <TError = Error, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSitePlugin>>,
    TError,
    { id: SiteID; data: UpdatePluginRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateSitePlugin>>,
  TError,
  { id: SiteID; data: UpdatePluginRequest },
  TContext
> => {
  const mutationKey = ['updateSitePlugin'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateSitePlugin>>,
    { id: SiteID; data: UpdatePluginRequest }
  > = props => {
    const { id, data } = props ?? {};

    return updateSitePlugin(id, data);
  };

  const customOptions = addMetaToMutation(
    { ...mutationOptions, mutationFn },
    { url: `/v1/sites/{id}/plugins` },
    {
      operationId: 'app.controllers.plugins_controller.update_site_plugin',
      operationName: 'updateSitePlugin',
    }
  );

  return customOptions;
};

export type UpdateSitePluginMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateSitePlugin>>
>;
export type UpdateSitePluginMutationBody = UpdatePluginRequest;
export type UpdateSitePluginMutationError = Error;

/**
 * @summary Update a WordPress plugin
 */
export const useUpdateSitePlugin = <TError = Error, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateSitePlugin>>,
      TError,
      { id: SiteID; data: UpdatePluginRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateSitePlugin>>,
  TError,
  { id: SiteID; data: UpdatePluginRequest },
  TContext
> => {
  const mutationOptions = getUpdateSitePluginMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Removes one or more installed plugins. Must-use plugins cannot be removed. WordPress sites only.
 * @summary Uninstall WordPress plugins
 */
export const deleteSitePlugin = (id: SiteID, deletePluginRequest: DeletePluginRequest) => {
  return customFetch<DeletePluginResponse>({
    url: `/v1/sites/${id}/plugins`,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json' },
    data: deletePluginRequest,
  });
};

export const getDeleteSitePluginMutationOptions = <TError = Error, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSitePlugin>>,
    TError,
    { id: SiteID; data: DeletePluginRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSitePlugin>>,
  TError,
  { id: SiteID; data: DeletePluginRequest },
  TContext
> => {
  const mutationKey = ['deleteSitePlugin'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSitePlugin>>,
    { id: SiteID; data: DeletePluginRequest }
  > = props => {
    const { id, data } = props ?? {};

    return deleteSitePlugin(id, data);
  };

  const customOptions = addMetaToMutation(
    { ...mutationOptions, mutationFn },
    { url: `/v1/sites/{id}/plugins` },
    {
      operationId: 'app.controllers.plugins_controller.delete_site_plugin',
      operationName: 'deleteSitePlugin',
    }
  );

  return customOptions;
};

export type DeleteSitePluginMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSitePlugin>>
>;
export type DeleteSitePluginMutationBody = DeletePluginRequest;
export type DeleteSitePluginMutationError = Error;

/**
 * @summary Uninstall WordPress plugins
 */
export const useDeleteSitePlugin = <TError = Error, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteSitePlugin>>,
      TError,
      { id: SiteID; data: DeletePluginRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteSitePlugin>>,
  TError,
  { id: SiteID; data: DeletePluginRequest },
  TContext
> => {
  const mutationOptions = getDeleteSitePluginMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Installs or reinstalls Rocket's CDN cache management plugin so the site can purge its CDN cache from WordPress. WordPress sites only.
 * @summary Install the Rocket CDN cache management plugin for WordPress
 */
export const installSiteCdnCacheManagementPlugin = (id: SiteID, signal?: AbortSignal) => {
  return customFetch<SuccessResponse>({
    url: `/v1/sites/${id}/plugins/rocket/cdn_cache_management`,
    method: 'POST',
    signal,
  });
};

export const getInstallSiteCdnCacheManagementPluginMutationOptions = <
  TError = Error,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof installSiteCdnCacheManagementPlugin>>,
    TError,
    { id: SiteID },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof installSiteCdnCacheManagementPlugin>>,
  TError,
  { id: SiteID },
  TContext
> => {
  const mutationKey = ['installSiteCdnCacheManagementPlugin'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof installSiteCdnCacheManagementPlugin>>,
    { id: SiteID }
  > = props => {
    const { id } = props ?? {};

    return installSiteCdnCacheManagementPlugin(id);
  };

  const customOptions = addMetaToMutation(
    { ...mutationOptions, mutationFn },
    { url: `/v1/sites/{id}/plugins/rocket/cdn_cache_management` },
    {
      operationId: 'app.controllers.plugins_controller.install_site_cdn_cache_management_plugin',
      operationName: 'installSiteCdnCacheManagementPlugin',
    }
  );

  return customOptions;
};

export type InstallSiteCdnCacheManagementPluginMutationResult = NonNullable<
  Awaited<ReturnType<typeof installSiteCdnCacheManagementPlugin>>
>;

export type InstallSiteCdnCacheManagementPluginMutationError = Error;

/**
 * @summary Install the Rocket CDN cache management plugin for WordPress
 */
export const useInstallSiteCdnCacheManagementPlugin = <TError = Error, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof installSiteCdnCacheManagementPlugin>>,
      TError,
      { id: SiteID },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof installSiteCdnCacheManagementPlugin>>,
  TError,
  { id: SiteID },
  TContext
> => {
  const mutationOptions = getInstallSiteCdnCacheManagementPluginMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Searches plugins available from the WordPress plugin directory. Supports keyword search, pagination, and browse modes. WordPress sites only.
 * @summary Search the WordPress plugin directory
 */
export const searchSitePlugins = (
  id: SiteID,
  params?: SearchSitePluginsParams,
  signal?: AbortSignal
) => {
  return customFetch<SearchPluginsResponse>({
    url: `/v1/sites/${id}/plugins/search`,
    method: 'GET',
    params,
    signal,
  });
};

export const getSearchSitePluginsQueryKey = (id?: SiteID, params?: SearchSitePluginsParams) => {
  return [`/v1/sites/${id}/plugins/search`, ...(params ? [params] : [])] as const;
};

export const getSearchSitePluginsQueryOptions = <
  TData = Awaited<ReturnType<typeof searchSitePlugins>>,
  TError = Error,
>(
  id: SiteID,
  params?: SearchSitePluginsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof searchSitePlugins>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSearchSitePluginsQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof searchSitePlugins>>> = ({ signal }) =>
    searchSitePlugins(id, params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, params },
    {
      url: `/v1/sites/${id}/plugins/search`,
      operationId: 'app.controllers.plugins_controller.search_site_plugins',
      operationName: 'searchSitePlugins',
    }
  );

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof searchSitePlugins>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type SearchSitePluginsQueryResult = NonNullable<
  Awaited<ReturnType<typeof searchSitePlugins>>
>;
export type SearchSitePluginsQueryError = Error;

export function useSearchSitePlugins<
  TData = Awaited<ReturnType<typeof searchSitePlugins>>,
  TError = Error,
>(
  id: SiteID,
  params: undefined | SearchSitePluginsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof searchSitePlugins>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchSitePlugins>>,
          TError,
          Awaited<ReturnType<typeof searchSitePlugins>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSearchSitePlugins<
  TData = Awaited<ReturnType<typeof searchSitePlugins>>,
  TError = Error,
>(
  id: SiteID,
  params?: SearchSitePluginsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof searchSitePlugins>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchSitePlugins>>,
          TError,
          Awaited<ReturnType<typeof searchSitePlugins>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSearchSitePlugins<
  TData = Awaited<ReturnType<typeof searchSitePlugins>>,
  TError = Error,
>(
  id: SiteID,
  params?: SearchSitePluginsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof searchSitePlugins>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Search the WordPress plugin directory
 */

export function useSearchSitePlugins<
  TData = Awaited<ReturnType<typeof searchSitePlugins>>,
  TError = Error,
>(
  id: SiteID,
  params?: SearchSitePluginsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof searchSitePlugins>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getSearchSitePluginsQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getSearchSitePluginsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof searchSitePlugins>>,
  TError = Error,
>(
  id: SiteID,
  params?: SearchSitePluginsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof searchSitePlugins>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSearchSitePluginsQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof searchSitePlugins>>> = ({ signal }) =>
    searchSitePlugins(id, params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, params },
    {
      url: `/v1/sites/${id}/plugins/search`,
      operationId: 'app.controllers.plugins_controller.search_site_plugins',
      operationName: 'searchSitePlugins',
    }
  );

  return customOptions as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof searchSitePlugins>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type SearchSitePluginsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof searchSitePlugins>>
>;
export type SearchSitePluginsSuspenseQueryError = Error;

export function useSearchSitePluginsSuspense<
  TData = Awaited<ReturnType<typeof searchSitePlugins>>,
  TError = Error,
>(
  id: SiteID,
  params: undefined | SearchSitePluginsParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof searchSitePlugins>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSearchSitePluginsSuspense<
  TData = Awaited<ReturnType<typeof searchSitePlugins>>,
  TError = Error,
>(
  id: SiteID,
  params?: SearchSitePluginsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof searchSitePlugins>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSearchSitePluginsSuspense<
  TData = Awaited<ReturnType<typeof searchSitePlugins>>,
  TError = Error,
>(
  id: SiteID,
  params?: SearchSitePluginsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof searchSitePlugins>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Search the WordPress plugin directory
 */

export function useSearchSitePluginsSuspense<
  TData = Awaited<ReturnType<typeof searchSitePlugins>>,
  TError = Error,
>(
  id: SiteID,
  params?: SearchSitePluginsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof searchSitePlugins>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getSearchSitePluginsSuspenseQueryOptions(id, params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
